export default __webpack_public_path__ + "locales/ja-JP/Translations.json?hash=3e609d31662d2f67464c96d5480448e9";